import { Button, Typography } from '@material-ui/core';
import React, { PureComponent } from 'react';
import QueryEditor from './QueryEditor';

class RequestPanel extends PureComponent {
    render() {
        const content = this.props.environment.app.user ? (
            <QueryEditor
                value={this.props.query}
                schema={this.props.environment.schema}
                onClickReference={() => {}}
                onEdit={this.props.onEditQuery}
                onRunQuery={this.props.onExecuteRequest}/>
        ) : (
            <div className="overlay">
                <Typography color="textSecondary" variant="subheading" gutterBottom>Sign-in as an admin on {this.props.environmentKey}</Typography>
                <Button variant="raised" color="primary" onClick={this.props.onLogin}>Authorize</Button>
            </div>
        );
        return (
            <div className="request-panel">
                <div className="request-panel-header">
                    <div className="grow">
                        <Button variant="flat" onClick={this.props.onSaveQuery} disabled={!this.props.saveEnabled}>Save</Button>
                    </div>
                    <div className="request-panel-right">
                        <Button variant="raised" color="primary" onClick={this.props.onExecuteRequest} disabled={!this.props.sendEnabled}>Send</Button>
                    </div>
                </div>
                {content}
            </div>
        );
    }
}

export default RequestPanel;



// WEBPACK FOOTER //
// ./src/components/RequestPanel.js